/*
  Mije Seoul — Collection screen behaviour.
  - Filters auto-submit (GET → filter params in URL, shareable/back-navigable)
  - Dual-handle price slider (2px track, readout label)
  - Load more: fetches the next page and appends cards; progress = loaded/total
  - Mobile filter sheet open/close
  No framework; degrades to plain pagination + form submit without JS.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var form = document.getElementById('MijeFacets');

  /* ------------------------------------------------------------ submit */

  function submitFilters() {
    if (!form) return;
    // only the visible sort select may submit, and price inputs at their
    // extremes are dropped so the URL stays clean
    var sorts = document.querySelectorAll('[data-sort]');
    sorts.forEach(function (s) {
      s.disabled = s.offsetParent === null;
    });
    var priceMin = form.querySelector('[data-price-min]');
    var priceMax = form.querySelector('[data-price-max]');
    if (priceMin && Number(priceMin.value) <= Number(priceMin.min)) priceMin.disabled = true;
    if (priceMax && Number(priceMax.value) >= Number(priceMax.max)) priceMax.disabled = true;
    form.submit();
  }

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-price-min], [data-price-max]')) {
        clampPrice(e.target);
      }
      submitFilters();
    });
  }

  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', submitFilters);
  });

  /* ------------------------------------------------------ price slider */

  var facetPrice = form && form.querySelector('[data-facet-price]');

  function clampPrice(changed) {
    if (!facetPrice) return;
    var lo = facetPrice.querySelector('[data-price-min]');
    var hi = facetPrice.querySelector('[data-price-max]');
    if (Number(lo.value) > Number(hi.value)) {
      if (changed === lo) hi.value = lo.value;
      else lo.value = hi.value;
    }
  }

  function paintPrice() {
    if (!facetPrice) return;
    var lo = facetPrice.querySelector('[data-price-min]');
    var hi = facetPrice.querySelector('[data-price-max]');
    var fill = facetPrice.querySelector('[data-price-fill]');
    var readout = facetPrice.querySelector('[data-price-readout]');
    var max = Number(facetPrice.dataset.max) || 1;
    var a = Number(lo.value);
    var b = Number(hi.value);
    if (fill) {
      fill.style.left = (a / max) * 100 + '%';
      fill.style.right = 100 - (b / max) * 100 + '%';
    }
    if (readout) {
      var symbol = readout.textContent.trim().charAt(0) || '$';
      readout.textContent = symbol + a + ' — ' + symbol + b;
    }
  }

  if (facetPrice) {
    facetPrice.addEventListener('input', function (e) {
      clampPrice(e.target);
      paintPrice();
    });
    paintPrice();
  }

  /* -------------------------------------------------------- load more */

  var loadMore = root.querySelector('[data-load-more]');
  var total = Number(root.dataset.total) || 0;
  var shown = Number(root.dataset.shown) || 0;

  function lastGrid() {
    var grids = root.querySelectorAll('[data-grid-items]');
    return grids[grids.length - 1];
  }

  function updateProgress() {
    var label = root.querySelector('[data-shown-label]');
    if (label) label.textContent = String(shown);
    var fill = root.querySelector('[data-progress-fill]');
    if (fill && total > 0) fill.style.width = Math.round((shown / total) * 100) + '%';
  }

  if (loadMore) {
    loadMore.addEventListener('click', function (e) {
      e.preventDefault();
      if (loadMore.getAttribute('aria-busy') === 'true') return;
      loadMore.setAttribute('aria-busy', 'true');
      var prevLabel = loadMore.textContent;
      loadMore.textContent = 'Loading…';

      fetch(loadMore.href)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelectorAll('[data-grid-items] > article');
          var target = lastGrid();
          incoming.forEach(function (card) {
            target.appendChild(document.importNode(card, true));
          });
          shown += incoming.length;
          if (shown > total) shown = total;
          updateProgress();

          var next = doc.querySelector('[data-load-more]');
          if (next && shown < total) {
            loadMore.href = next.href;
            loadMore.textContent = prevLabel;
            loadMore.removeAttribute('aria-busy');
          } else {
            loadMore.remove();
          }
        })
        .catch(function () {
          // fall back to plain navigation on any fetch failure
          loadMore.removeAttribute('aria-busy');
          window.location.href = loadMore.href;
        });
    });
  }

  /* ----------------------------------------------------- filter sheet */

  var sheet = root.querySelector('[data-facet-sheet]');
  var scrim = root.querySelector('[data-facet-scrim]');
  var openBtn = root.querySelector('[data-facet-open]');
  var closeBtn = root.querySelector('[data-facet-close]');

  function setSheet(open) {
    if (!sheet) return;
    sheet.classList.toggle('is-open', open);
    if (scrim) scrim.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  if (openBtn) openBtn.addEventListener('click', function () { setSheet(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setSheet(false); });
  if (scrim) scrim.addEventListener('click', function () { setSheet(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setSheet(false);
  });
})();
